module.exports = __webpack_public_path__ + "81005e7a1099d733104caf4b0d06a225.png";